/* Axios Intercepter actions for global loading spinner */

export const spinningAction = (globalState, bool) => {
  return {
    ...globalState,
    isLoading: bool,
  };
};
